<script>
  export let size = 28;
</script>

<svg
  width={size}
  height={size * (33 / 34)}
  viewBox="0 0 34 33"
  fill="none"
  aria-hidden="true"
  style="display:block"
>
  <defs>
    <linearGradient id="ace-logo-a" x1="17" y1="6" x2="8" y2="25" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#3EA0EC" />
      <stop offset="0.5" stop-color="#357BF9" />
      <stop offset="1" stop-color="#1B49F0" />
    </linearGradient>
    <linearGradient id="ace-logo-b" x1="22" y1="14" x2="27" y2="26" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#3191F4" />
      <stop offset="1" stop-color="#2581FA" />
    </linearGradient>
  </defs>
  <path
    d="M16.6 7 L7.3 24.5 L17.5 24.5"
    stroke="url(#ace-logo-a)"
    stroke-width="6.1"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M21.7 15.4 L26.9 25.1"
    stroke="url(#ace-logo-b)"
    stroke-width="6.6"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
